module.exports = __webpack_public_path__ + "static/media/logoV1RAGEdark.39fcd909.svg";